<template>
  <div>
    <el-empty :description="title"></el-empty>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "暂无数据~"
    }
  },
  data() {
    return {};
  },
};
</script>

<style></style>